import { FiCheck } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi";
import { MANAGE_MATERIALS } from "../../routes";
import { ROLES } from "../../Constants/Strings";
import { MdEdit } from "react-icons/md";
import { TbProgressCheck } from "react-icons/tb";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaTools } from "react-icons/fa";
import { IoDocuments } from "react-icons/io5";
import { BiUpload } from "react-icons/bi";

export const FILTER_OPTIONS = {
  STATUS: ["ALL", "COMPLETED", "IN_PROGRESS", "PENDING"],
  TYPE: ["ALL", "DCR", "NON_DCR"],
};

export const PROJECT_TYPE_LABELS = {
  ALL: "All",
  DCR: "DCR",
  NON_DCR: "Non DCR",
};

export const LABELS = {
  STATUS: "Status",
  TYPE: "Type",
  LOADING: "Loading projects...",
  NO_PROJECTS: "No Projects",
  EXPAND: "",
  PROJECT_NAME: "Project Name",
  CAPACITY: "Capacity (kW)",
  TYPE_COL: "Type",
  CLIENT_NAME: "Client Name",
  NOT_COMPLETED: "Not Completed",
  IN_PROGRESS: "In Progress",
  ACTIONS: "Actions",
  VIEW: "View",
  EDIT: "Edit",
  DELETE: "Delete",
  PROJECT_CODE: "Project Code",
};

export const STATUS_VALUES = {
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  PENDING: "Pending",
};

export const REQUIRED_FIELDS = {
  PROJECT_NAME: "Project name is required",
  ESTIMATED_START_DATE: "Estimated start date is required",
  ESTIMATED_END_DATE: "Estimated end date is required",
  CAPACITY: "Capacity is required",
  TYPE: "Project type is required",
  CLIENT_NAME: "Client name is required",
  CLIENT_EMAIL: "Client email is required",
  CLIENT_PHONE: "Client phone number is required",
  CLIENT_ADDRESS: "Client address is required",
  INVALID_EMAIL: "Invalid email format",
};

export const VALIDATION_MESSAGES = {
  VALID_NUMBER: "Client phone must be a valid number",
  START_DATE: "Start Date cannot be in the past",
  END_DATE: "Estimated End Date cannot be in the past",
};

export const MESSAGES = {
  CONFIRM_DELETE: "Are you sure you want to delete this material?",
};

export const TOAST_MESSAGES = {
  PROJECT_FETCH_FAILED: "Failed To Load Projects..",
  PROJECT_CREATED: "Project created successfully",
  PROJECT_CREATION_FAILED: "Project creation failed",
  PROJECT_CREATION_ERROR: "An error occurred while creating the project",
  PROJECT_GET_DETAILS_ERROR: "An error occurred while fetching project details",
  PROJECT_DETAILS_FETCHED: "Project details fetched successfully",
  ERROR_FETCHING_MATERIALS: "Error Fetching Materials",
  DELETE_SUCCESSFUL: "Item deleted successfully",
  DELETE_UNSUCCESSFUL: "Unable to delete item",
  SOMETHING_WENT_WRONG: "Something went wrong",
  MATERIAL_UPDATED: "Materials Updated Successfully",
  UPDATION_FAILED: "Failed Updation",
  FILE_UPLOADED_SUCCESFULLY: "File Uploaded Successfully",
  FILE_UPLOAD_FAILED: "Failed to upload file",
  NO_MILESTONE_SELECTED: "No milestone selected",
  ACTION_COMPLETED_SUCCESSFULLY: "Action Completed Successfully",
  ACTION_FAILED: "Action Failed",
  FILES_FETCHED: "Files fetched successfully",
  FILES_FETCHED_ERROR: "Failed to fetch files",
  MATERIAL_ADDED: "Material Added Successfully",
  MATERIAL_ADD_FAILED: "Failed To Add Material",
  PAYMENT_FETCH_FAILED: "An error occurred while fetching payment timeline",
  SUBMILESTONE_FETCH_FAIL: "failed to fetch sub milestones",
  PROJECT_UPDATE_SUCCESS: "Project Details Updated Successfully",
  PROJECT_UPDATE_FAILED: "Failed To Update Project Details",
  PAYMENT_UPDATE_SUCCESS: "Payment details updated successfully!",
  PAYMENT_UPDATE_FAILED: "Failed to update payment details",
  MILESTONE_FETCH_FAILED: "Failed to fetch milestones..",
  PAYMENT_ADD_SUCCESS: "Payment Added Successfully.",
  NO_FILE_SELECTED: "No file selected for upload",
  PAYMENT_ADD_FAILED: "Failed To Add Payment..",
  STATUS_UPDATE_SUCCESS: "Status updated successfully..",
  STATUS_UPDATE_FAIL: "Fail to updated status",
  CANNOT_COMPLETE: "Milestone must be In Progress before it can be Completed",
  CONTACT_DETAILS_FAILED: "Failed to fetch contact details",
  FAILED_ADD_CONTACT: "Failed to add contact",
  ADD_CONTACT_SUCCESS: "Contact added successfully",
  DELETE_CONTACT_SUCCESS: "Contact deleted successfully",
  DELETE_CONTACT_ERROR: "Failed to delete contact details",
  FILE_DELETE_SUCESS: "File Deleted Successfully",
  FILE_DELETE_FAIL: "Failed to delete file",
  ERROR_FETCHING_USERS: "Error fetching users",
  USER_UPDATED: "User updated successfully",
  USER_UPDATION_FAILED: "Failed to update user",
  FILE_DELETE_SUCCESS: "File Deleted Successfully",
  FILE_DELETE_ERROR: "Error deleting file",
  FILE_DOWNLOAD_SUCCESSFUL: "File downloaded successfully",
  FILE_DOWNLOAD_FAIL: "Failed to download",
  BULK_UPDATE_SUCCESS : "Selected materials marked as delivered",
  BULK_UPDATE_FAIL : "Failed marked as delivered"
};

export const STATUS_CONFIG = {
  [STATUS_VALUES.COMPLETED]: {
    color: "bg-green-500 text-white",
    bg: "bg-green-100 text-green-800",
    icon: <FiCheck className=" text-white" aria-hidden size={30} />,
    text: "Completed",
  },
  [STATUS_VALUES.IN_PROGRESS]: {
    color: "bg-primary text-white",
    bg: "bg-sky-100 text-sky-800",
    icon: (
      <HiOutlineDocumentText className=" text-white" aria-hidden size={30} />
    ),
    text: "In Progress",
  },
  default: {
    color: "bg-gray-300 text-gray-700",
    bg: "bg-gray-100 text-gray-700",
    icon: (
      <HiOutlineDocumentText className=" text-gray-500" aria-hidden size={30} />
    ),
    text: "Pending",
  },
};

export const STATUS = {
  ALL: "All",
  PENDING: "Not Started",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
};

export const STATUS_VALUE = {
  All: "",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  PENDING: "PENDING",
};

export const PROJECT_TYPES = [
  { value: "DCR", label: "DCR" },
  { value: "NON_DCR", label: "Non DCR" },
];

export const FILE_TABLE_COLUMNS = ["File", "Actions"];
export const MATERIAL_COLUMNS = [
  { key: "material_name", label: "Material Name" },
  { key: "specification", label: "Specification" },
  { key: "unit", label: "Unit" },
  { key: "quantity", label: "Quantity" },
  { key: "material_delivery_date", label: "Delivery Date" },
  { key: "material_delivery_status", label: "Status" },
  { key: "file", label: "File" },
];

export const MATERIAL_RENDER_FIELDS = {
  material_name: { type: "TEXT" },
  specification: { type: "TEXT" },
  unit: { type: "TEXT" },
  quantity: { type: "TEXT" },
  material_delivery_date: { type: "DATE" },
  material_delivery_status: {
    type: "SELECT",
    dropdownValues: ["PENDING", "DELIVERED", "CANCELLED"],
  },
  file: { type: "FILE" },
};

export const MATERIAL_FORM_LABELS = MATERIAL_COLUMNS.reduce((labels, col) => {
  labels[col.key] = col.label;
  return labels;
}, {});

export const ADD_MATERIAL_RENDER_FIELDS = {
  material_name: { type: "TEXT" },
  specification: { type: "TEXT" },
  unit: { type: "TEXT" },
  quantity: { type: "TEXT" },
};

export const ADD_MATERIAL_FORM_LABELS = {
  material_name: "Material Name",
  specification: "Specification",
  unit: "Unit",
  quantity: "Quantity",
};

export const ACTION_LIST = {
  UPLOAD: "UPLOAD",
  REDIRECT: "REDIRECT",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  PENDING: "PENDING",
  OPEN_POPUP: "OPEN_POPUP",
  CUSTOMER_ACK: "CUSTOMER_ACK",
  VIEW_DOCUMENTS: "VIEW_DOCUMENTS"
};

export const STATUS_ACTION_FILTERS = {
  PENDING: ["COMPLETED"], // hide completed
  IN_PROGRESS: ["IN_PROGRESS", "PENDING"], // hide in_progress
  COMPLETED: ["COMPLETED", "IN_PROGRESS", "PENDING"], // hide both
};

export const ACK_ACTION_FILTERS = {
  PENDING: ["PENDING"], // hide completed
  COMPLETED: ["COMPLETED", "PENDING"], // hide both
};

export const MILESTONE_ACTIONS = {
  Start: [
    { label: "Mark as In Progress", type: "IN_PROGRESS", icon: <MdEdit /> },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <TbProgressCheck />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  "Sanction Letter": [
    { label: `Edit Sanction Letter`, type: "OPEN_POPUP", icon: <MdEdit /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  Procurement: [
    {
      label: "Manage Procurement",
      type: "REDIRECT",
      url: MANAGE_MATERIALS,
      icon: <FaTools />,
    },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  Structure: [
    { label: "Structure Image", type: "OPEN_POPUP", icon: <BiUpload /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  "Electrical Installation": [
    { label: "Edit Electrical", type: "OPEN_POPUP", icon: <MdEdit /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  Documentation: [
    { label: "Edit Documentation", type: "OPEN_POPUP", icon: <MdEdit /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  "Meter Installation": [
    { label: "Edit Meter", type: "OPEN_POPUP", icon: <MdEdit /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  Commission: [
    { label: "Edit Commission", type: "OPEN_POPUP", icon: <MdEdit /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
  Handover: [
    { label: "View Documents", type: "VIEW_DOCUMENTS", icon: <IoDocuments /> },
    {
      label: "Mark as In Progress",
      type: "IN_PROGRESS",
      icon: <TbProgressCheck />,
    },
    {
      label: "Mark as Completed",
      type: "COMPLETED",
      icon: <FaRegCheckCircle />,
    },
    { label: "Acknowledge", type: "CUSTOMER_ACK", status: "COMPLETED" },
  ],
};

export const USER_COLUMNS = [
  { key: "full_name", label: "Name" },
  { key: "mobile", label: "Mobile" },
  { key: "company", label: "Company" },
  { key: "role", label: "Role" },
  { key: "is_approved", label: "Status" },
];

export const USER_FORM_LABELS = {
  role: "Role",
  is_approved: "Active Status",
};

export const ROLES_ARRAY = [
  { value: "ADMIN", label: "Admin" },
  { value: "USER", label: "User" },
  { value: "CUSTOMER", label: "Customer" },
];

export const STATUS_OPTIONS = {
  ACTIVE: "Active",
  DEACTIVE: "Deactive",
};

export const POPUP_TABS = {
  PROJECT_TAB: "project",
  MATERIAL_TAB: "material",
  VENDOR_TAB: "vendor"
};

export const TABS = [
  { key: "project", label: "Project Details" },
  { key: "material", label: "Material Details" },
  { key: "vendor", label: "Vendor Details" },
];

const commonCSS = "p-2 border text-gray-700";

export const PAYMENT_TIMELINE_COLUMNS = [
  { label: "Project Name", commonCSS },
  { label: "Amount", commonCSS },
  { label: "Status", commonCSS },
  { label: "Date", commonCSS },
  { label: "Description", commonCSS },
];

export const MATERIAL_TABLE_COLUMNS = [
  { label: "Project Name", commonCSS },
  { label: "Material Name", commonCSS },
  { label: "Quantity", commonCSS },
  { label: "Specification", commonCSS },
  { label: "Unit", commonCSS },
  { label: "Delivery Date", commonCSS },
  { label: "Status", commonCSS },
];

export const ACTION_ROLE_MAP = {
  [ACTION_LIST.CUSTOMER_ACK]: [ROLES.CUSTOMER],
  [ACTION_LIST.OPEN_POPUP]: [ROLES.USER, ROLES.ADMIN, ROLES.CUSTOMER],
  [ACTION_LIST.REDIRECT]: [ROLES.USER, ROLES.ADMIN, ROLES.CUSTOMER],
};

export const contact_renderFieldConfig = {
  person_name: { type: "TEXT" },
  mobile: { type: "TEXT" },
  email: { type: "TEXT" },
  service_description: { type: "TEXT" },
  type: {
    type: "SELECT",
    dropdownValues: ["DISCOM", "INVERTER_VENDOR", "PANEL_VENDOR", "OTHER"],
  },
};

export const contact_formFieldLabels = {
  person_name: "Name *",
  mobile: "Contact Number *",
  email: "Email",
  service_description: "Service Description",
  type: "Type *",
  DISCOM: "DISCOM",
  INVERTER_VENDOR: "Inverter Vendor",
  PANEL_VENDOR: "Panel Vendor",
  OTHER: "Other",
};

export const VENDOR_TYPE_CONSTANTS = [
  { label: "DISCOM", value: "DISCOM" },
  { label: "Inverter Vendor", value: "INVERTER_VENDOR" },
  { label: "Panel Vendor", value: "PANEL_VENDOR" },
  { label: "Other", value: "OTHER" },
];

export const avatarColors = [
  "bg-pink-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-purple-500",
  "bg-indigo-500",
  "bg-red-500",
];

export const project_formFieldLabels = {
  name: "Project Name",
  company: "Company Name",
  capacity: "Capacity (KW)",
  type: "Project Type",
  estimated_start_date: "Estimated Start Date",
  estimated_end_date: "Estimated End Date",
  map_url: "Map Url",
  client_name: "Client Name",
  client_phone: "Phone",
  client_email: "Email",
  client_address: "Address",
  client_category: "Category",
  client_district: "District",
  client_aadhar_number: "Aadhar Number",
  subsidy_vendor_name: "Vendor Name",
  subsidy_vendor_email: "Email",
  subsidy_vendor_phone: "Phone",
  subsidy_vendor_representative: "Representative",
  vendor_designation: "Designation",
  vendor_address: "Address",
  representative_designation: "Representative Designation",
  re_resource: "RE Resource",
  re_installed_capacity_rooftop: "Installed Capacity Rooftop",
  re_installed_capacity_rooftop_ground: "Installed Capacity (Rooftop + Ground)",
  re_installed_capacity_ground: "Installed Capacity Ground",
  sanctioned_capacity_solar_pv_system_installed:
    "Sanctioned Capacity Installed",
  sanctioned_capacity: "Sanctioned Capacity",
  capacity_type: "Capacity Type",
};


export const DOCUMENT_CATEGORIES = [
  {label:"Purchase", value:"PURCHASE"},
  {label:"Sale", value:"SALE"},
  {label:"Design", value:"DESIGN"},
  {label:"Official Document", value:"OFFICIAL_DOCUMENT"},
  {label:"Other", value:"OTHER"}
]
